import classNames from 'classnames';
import useId from '../utilities/useId';
import { CloseIconThin } from '../Icons';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 */
export const CloseButton = _ref => {
  let {
    className,
    id: idProp,
    ariaHidden = false,
    ...buttonAttributes
  } = _ref;
  const id = useId('close-button--', idProp);
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    ...buttonAttributes,
    className: classNames('ds-c-close-button', className),
    id: id,
    children: /*#__PURE__*/_jsx(CloseIconThin, {
      ariaHidden: ariaHidden,
      id: `${id}__icon`
    })
  });
};
export default CloseButton;